import { render, staticRenderFns } from "./FactsSection.vue?vue&type=template&id=a3662004&"
import script from "./FactsSection.vue?vue&type=script&lang=js&"
export * from "./FactsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports